import React, { useState } from "react";
import AddSale from "./addSale";
import SaleList from "./saleList";

function ViewSale() {
  const [refreshKey, setRefreshKey] = useState(0);
  const refreshSaleList = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };
  return (
    <>
      <AddSale onSaleAdded={refreshSaleList} />
      <div className="whiteBgDiv dashboardTablePadding">
        <SaleList key={refreshKey} />
      </div>
    </>
  );
}

export default ViewSale;
